import ertSelectComponent from './select.component';

const ertSelect = angular.module('app.common.ertSelect', [])
	.component('ertSelect', ertSelectComponent)
	.name;

export default ertSelect;
